export const ScrollReset: string = "scrollReset"
